import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react'
import { Toaster as Sonner } from 'sonner'
import type { ToasterProps } from 'sonner'
import type { CSSProperties } from 'react'
import { useTheme } from '@/shared/theme/use-theme'

function getSonnerTheme(
  effectiveMode: string,
): NonNullable<ToasterProps['theme']> {
  return effectiveMode === 'dark' ? 'dark' : 'light'
}

export function Toaster(props: ToasterProps) {
  const { effectiveMode } = useTheme()

  return (
    <Sonner
      {...props}
      theme={getSonnerTheme(effectiveMode)}
      position="top-center"
      className="toaster group"
      toastOptions={{
        ...props.toastOptions,
        actionButtonStyle: {
          background: 'var(--primary)',
          color: 'var(--primary-foreground)',
          ...props.toastOptions?.actionButtonStyle,
        },
        cancelButtonStyle: {
          background: 'var(--secondary)',
          color: 'var(--secondary-foreground)',
          ...props.toastOptions?.cancelButtonStyle,
        },
      }}
      icons={{
        success: <CircleCheckIcon className="size-4 text-primary" />,
        info: <InfoIcon className="size-4 text-primary" />,
        warning: <TriangleAlertIcon className="size-4 text-primary" />,
        error: <OctagonXIcon className="size-4 text-popover-foreground" />,
        loading: <Loader2Icon className="size-4 animate-spin text-primary" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--normal-bg-hover': 'var(--accent)',
          '--normal-border-hover': 'var(--ring)',
          '--success-bg': 'var(--popover)',
          '--success-text': 'var(--popover-foreground)',
          '--success-border': 'var(--border)',
          '--info-bg': 'var(--popover)',
          '--info-text': 'var(--popover-foreground)',
          '--info-border': 'var(--border)',
          '--warning-bg': 'var(--popover)',
          '--warning-text': 'var(--popover-foreground)',
          '--warning-border': 'var(--border)',
          '--error-bg': 'var(--popover)',
          '--error-text': 'var(--popover-foreground)',
          '--error-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as CSSProperties
      }
    />
  )
}
